import { ACTION_REMOVE_WAITLIST_ENTRY } from 'utils/analytics/eventTypeConstantsAmplitude';
import { Button, Dialog, DialogActions, DialogContent, DialogHeading, Typography } from 'omakase';
import { WaitlistDeleteConfirmationModalFragment } from 'generated/graphql';
import { gql } from '@apollo/client/core';
import { showError, showInfo } from '@tock/toast';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { useDispatch } from 'react-redux';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  id?: number;
  onDelete: (id: number) => Promise<void>;
  data?: WaitlistDeleteConfirmationModalFragment;
}

export const WAITLIST_DELETE_CONFIRMATION_MODAL_FRAGMENT = gql`
  fragment WaitlistDeleteConfirmationModal on WaitlistEntity {
    id
    business {
      id
      name
      currencyCode
    }
    desiredSize
    ticketType {
      id
      name
    }
  }
`;

const WaitlistDeleteConfirmationModal: React.FC<Props> = ({
  isOpen = false,
  onClose,
  onDelete,
  id,
  data,
}) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const dispatch = useDispatch();
  return (
    <Dialog open={isOpen} variant="sheet" onClose={onClose}>
      <DialogHeading onClose={onClose}>Delete request</DialogHeading>
      <DialogContent>
        <Typography variant="body02">
          Are you sure you want to delete your Notify request at {data?.business?.name}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="basic" size="medium" fullWidth onClick={onClose}>
          Go back
        </Button>
        <Button
          variant="primary"
          size="medium"
          fullWidth
          onClick={async () => {
            if (!id) {
              onClose();
              return;
            }
            try {
              await onDelete(id);
              onClose();
              dispatch(showInfo('Your Notify request has been deleted'));

              amplitudeSendEvent(ACTION_REMOVE_WAITLIST_ENTRY, {
                businessId: data?.business?.id,
                businessName: data?.business?.name,
                currencyCode: data?.business?.currencyCode,
                partySize: Number(data?.desiredSize),
                experienceId: data?.ticketType?.id,
                experienceName: data?.ticketType?.name,
              });
            } catch (_error) {
              dispatch(
                showError('There was a problem deleting your Notify request. Please try again.')
              );
              onClose();
            }
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WaitlistDeleteConfirmationModal;
